import { JSX, ReactNode } from 'react';

interface Props {
  wrap: (element: ReactNode) => JSX.Element;
  children: ReactNode;
  condition: boolean;
}

export function ConditionalWrapper({ condition, wrap, children }: Props) {
  if (condition) {
    return wrap(children);
  }

  return children;
}
